"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceResponseBase = void 0;
const core = __importStar(require("../../../../core"));
const InvoiceStatus_1 = require("./InvoiceStatus");
const CurrencyCode_1 = require("../../paymentMethodTypes/types/CurrencyCode");
const EntityId_1 = require("../../entityTypes/types/EntityId");
const CounterpartyResponse_1 = require("../../entityTypes/types/CounterpartyResponse");
const PaymentMethodResponse_1 = require("../../paymentMethodTypes/types/PaymentMethodResponse");
const PaymentMethodId_1 = require("../../paymentMethodTypes/types/PaymentMethodId");
const PaymentDestinationOptions_1 = require("./PaymentDestinationOptions");
const InvoiceLineItemResponse_1 = require("./InvoiceLineItemResponse");
const ApprovalSlot_1 = require("./ApprovalSlot");
const ApprovalPolicyResponse_1 = require("../../entityTypes/types/ApprovalPolicyResponse");
const EntityUserResponse_1 = require("../../entityTypes/types/EntityUserResponse");
const CommentResponse_1 = require("./CommentResponse");
const InvoiceFeesResponse_1 = require("./InvoiceFeesResponse");
const PaymentSchedule_1 = require("./PaymentSchedule");
const OcrJobId_1 = require("../../ocr/types/OcrJobId");
exports.InvoiceResponseBase = core.serialization.object({
    status: InvoiceStatus_1.InvoiceStatus,
    amount: core.serialization.number().optional(),
    currency: CurrencyCode_1.CurrencyCode.optional(),
    invoiceDate: core.serialization.date().optional(),
    deductionDate: core.serialization.date().optional(),
    nextDeductionDate: core.serialization.date().optional(),
    dueDate: core.serialization.date().optional(),
    invoiceNumber: core.serialization.string().optional(),
    noteToSelf: core.serialization.string().optional(),
    serviceStartDate: core.serialization.date().optional(),
    serviceEndDate: core.serialization.date().optional(),
    payerId: EntityId_1.EntityId.optional(),
    payer: CounterpartyResponse_1.CounterpartyResponse.optional(),
    paymentSource: PaymentMethodResponse_1.PaymentMethodResponse.optional(),
    paymentSourceId: PaymentMethodId_1.PaymentMethodId.optional(),
    vendorId: EntityId_1.EntityId.optional(),
    vendor: CounterpartyResponse_1.CounterpartyResponse.optional(),
    paymentDestination: PaymentMethodResponse_1.PaymentMethodResponse.optional(),
    paymentDestinationId: PaymentMethodId_1.PaymentMethodId.optional(),
    paymentDestinationOptions: PaymentDestinationOptions_1.PaymentDestinationOptions.optional(),
    paymentDestinationConfirmed: core.serialization.boolean(),
    batchPayment: core.serialization.boolean().optional(),
    hasDocuments: core.serialization.boolean(),
    hasSourceEmail: core.serialization.boolean(),
    lineItems: core.serialization.list(InvoiceLineItemResponse_1.InvoiceLineItemResponse).optional(),
    taxAmount: core.serialization.number().optional(),
    shippingAmount: core.serialization.number().optional(),
    approvers: core.serialization.list(ApprovalSlot_1.ApprovalSlot),
    approvalPolicy: core.serialization.list(ApprovalPolicyResponse_1.ApprovalPolicyResponse),
    metadata: core.serialization.record(core.serialization.string(), core.serialization.string()),
    creatorEntityId: EntityId_1.EntityId.optional(),
    creatorUser: EntityUserResponse_1.EntityUserResponse.optional(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    comments: core.serialization.list(CommentResponse_1.CommentResponse).optional(),
    fees: InvoiceFeesResponse_1.InvoiceFeesResponse.optional(),
    paymentSchedule: PaymentSchedule_1.PaymentSchedule.optional(),
    ocrJobId: OcrJobId_1.OcrJobId.optional(),
});
